import { ImageServiceType } from '../constants';
import akamaiUrlToHighDpi from '../helpers/akamaiUrlToHighDpi';
import getImageServiceType from '../helpers/getImageServiceType';
import lpUrlToHighDpi from '../helpers/lpUrlToHighDpi';
/**
 * This function returns a high DPI image url.
 *
 * @param url - The image url.
 * @returns - Return a high DPI image url.
 */
const toHighDPIImageUrl = (url) => {
    const cdn = getImageServiceType(url);
    switch (cdn) {
        case ImageServiceType.AKAMAI:
            return akamaiUrlToHighDpi(url);
        case ImageServiceType.LIQUID_PIXELS:
            return lpUrlToHighDpi(url);
        case ImageServiceType.UNKNOWN:
        default:
            return url;
    }
};
export default toHighDPIImageUrl;
//# sourceMappingURL=toHighDPIImageUrl.js.map